module.exports = __webpack_public_path__ + "static/media/icons_Bilan Guillarme - Post Partum.b60f859c.svg";